define('fukit/configuration/active.product.collection.configuration',['require','exports','module','underscore','backbone.radio','bluebird','../model/product.model','../model/active.product.model','../helpers/collection.util','../helpers/roles.helper'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      Radio              = require('backbone.radio'),
      Promise            = require('bluebird'),
      ProductModel       = require('../model/product.model'),
      ActiveProductModel = require('../model/active.product.model'),
      CollectionUtil     = require('../helpers/collection.util'),
      RolesHelper        = require('../helpers/roles.helper');

  var ActiveProductCollectionConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function(app) {
      //prettier-ignore
      var activeProductCollection = new ActiveProductModel.Collection(),
          productCollection       = new ProductModel.Collection();

      productCollection.filters.addFilterWithField({ name: 'isProvisionable' }).equals(false);

      activeProductCollection.sort.makeAscending();
      Radio.request('AppKit.resourceService', 'registerResource', 'activeProductCollection', activeProductCollection);

      if (app && app.registerReadyInterceptor) {
        app.registerReadyInterceptor(function() {
          return new Promise(function(resolve) {
            var _hasSufficientPermissions = function(roles) {
              return RolesHelper.evaluateRoleArrayAgainstUserRoles(roles);
            };

            var _findProductsWithInsufficientPermissions = function(activeProductCollection) {
              var insufficientModels = [];

              activeProductCollection.each(function(model) {
                var baseAccessRoles = model.get('baseAccessRoles');

                if (!_.isUndefined(baseAccessRoles) && !_hasSufficientPermissions(baseAccessRoles)) {
                  insufficientModels.push(model);
                }
              });

              return insufficientModels;
            };

            Promise.all([activeProductCollection.fetch().promise(), productCollection.fetch().promise()]).done(
              function() {
                // cache the original active product collection before we massage it because we may need an
                // independent list of enabled products at some point.
                Radio.request(
                  'AppKit.resourceService',
                  'registerResource',
                  'enabledProductCollection',
                  CollectionUtil.clone(activeProductCollection)
                );

                Radio.request(
                  'AppKit.resourceService',
                  'registerResource',
                  'nonProvisionableProductCollection',
                  productCollection
                );
                var adminModel = productCollection.findWhere({ name: 'RS_ADMIN' });
                if (adminModel) {
                  adminModel.set({
                    active: RolesHelper.evaluateRolesOptions(adminModel.get('baseAccessRoles')),
                  });
                  //FIXME: When a proper icon image is provided for Admin, we no longer need to set icon and unset thumbnail
                  if (_.isEmpty(adminModel.get('thumbnail'))) {
                    adminModel.set({ icon: 'setting' });
                    adminModel.unset('thumbnail');
                  }
                }
                activeProductCollection.add(adminModel);
                activeProductCollection.remove(_findProductsWithInsufficientPermissions(activeProductCollection));
                CollectionUtil.removeWhere(activeProductCollection, { active: false });

                resolve();
              }
            );
          });
        });
      }
    },
  };

  module.exports = ActiveProductCollectionConfiguration;
});

